import React from 'react';
import { formatThousandthValue } from '@/pages/opinion/utils/value';
import { useIntl } from 'umi';
import { steamRateMap } from '@/pages/opinion/constants/channel';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { NO_DATE } from '@/pages/opinion/constants';
import SteamLineReviews from '@/pages/opinion/widgets/GameStorePlate/components/SteamLineReviews';
import { Bubble, Col, Row } from 'tea-component';
import { useSteamPercentage } from '../../hooks';
import ChannelLabel from '@op/components/ChannelLabel';
import SvgIcon from '@home/components/SvgIcon';
import BubbleCommon from '@op/components/BubbleCommon';
import './index.scss';

export default function SteamGameStore({
  title,
  keys,
  data,
  filter,
  className,
  isSelected = false,
  span = 24,
  titleIconEle = null,
  titleTips = null,
  showShare = true,
  showRatingView = true,
  timeTips = "from the game's release on Steam to {time}",
  shareClick,
  emptyHeight = 160,
  nearTotalTips,
  ...commonCardProps
}: any) {
  const { formatMessage } = useIntl();

  const { steamRenderBar, steamRenderReviewTotal, time } = useSteamPercentage({
    keys,
    data,
    filter,
    isSelected,
  });


  function getSteamRating() {
    let rating = steamRenderReviewTotal?.name;
    const info = steamRateMap[rating];
    const total = steamRenderReviewTotal?.review || 0;
    if (info) rating = info.name;
    return (
      <div className="context-box">
        {total === 0 ? '-' : formatMessage({ id: rating || NO_DATE.EMPTY })}
        <div className="context-number">
          {formatThousandthValue(total)} {formatMessage({ id: 'Reviews' })}
          <BubbleCommon
            tipsMap={nearTotalTips}
            childStyle={{ verticalAlign: 'middle' }}
            placement="top"
            showIcon={!!nearTotalTips}
          ></BubbleCommon>
        </div>
      </div>
    );
  }

  return (
    <div className={`steam-game-store-wrapper ${  className}`}>
      <CardCommon
        empty={(steamRenderReviewTotal?.review || 0) === 0}
        hasEmptyTitle={false}
        hasEmptyImg={false}
        contentCard
        emptyHeight={emptyHeight}
        {...commonCardProps}
        title={
          <SteamPlatformTitle
            title={title}
            channelName="steam"
            titleIconEle={titleIconEle}
            titleTips={titleTips}
            tipsMap={null}
            shareClick={shareClick}
            showShare={showShare}
            size={16}
            time={isSelected ? time : formatMessage({ id: timeTips }, { time })}
          ></SteamPlatformTitle>
        }
      >
        {showRatingView && (
          <>
            <div className="score-info">{getSteamRating()} </div>
            <Row className="steam-game-store-row">
              <Col span={span}>
                <SteamLineReviews
                  steamRenderReviewList={steamRenderBar}
                  reviewTotal={steamRenderReviewTotal?.review || 0}
                  formatNumber={formatThousandthValue}
                  showReviewTotal={false}
                ></SteamLineReviews>
              </Col>
            </Row>
          </>
        )}
      </CardCommon>
    </div>
  );
}

export function SteamPlatformTitle({
  channelName,
  title = NO_DATE.EMPTY,
  className,
  titleIconEle = null,
  titleTips = null,
  time = '',
  showShare = false,
  shareClick,
}: any) {
  const { formatMessage } = useIntl();

  return (
    <div className={`steam-platform-title-wrapper ${className}`}>
      <div className="item-title-box">
        {titleIconEle || (
          <ChannelLabel
            channel_name={channelName}
            showText={false}
            iconStyle={{ width: 16, height: 16 }}
            style={{ marginRight: 6 }}
          ></ChannelLabel>
        )}
        <span className="item-title-text">
          <label className="title-info">{formatMessage({ id: title })}</label>
          {showShare && (
            <Bubble
              content={formatMessage({
                id: 'Go to the original website (Steam).',
              })}
            >
              <label className="share-icon">
                <SvgIcon
                  onClick={() => shareClick?.()}
                  type="other-share-icon"
                />
              </label>
            </Bubble>
          )}
          <label className="item-time">{time}</label>
          {titleTips && (
            <BubbleCommon
              placement="top"
              childStyle={{ verticalAlign: 'text-top' }}
              tipsMap={titleTips}
            ></BubbleCommon>
          )}
        </span>
      </div>
    </div>
  );
}
